import React, { useEffect } from "react";
import preview from "assets/icons/preview.svg";
import Card from "components/common/Card";
import { useAppDispatch, useAppSelector } from "utils/hooks";
import { getQuestionsThunk, postQualityCheckThunk } from "store/thunk/kyp.thunk";
import { useNavigate, useParams } from "react-router-dom";
import Button from "components/semantic/Button";
import HealthLifestyle from "./components/Health&Lifestyle";
import FinancialOccupation from "./components/Financial&Occupation";
import ContactAdmin from "./components/Contact&Admin";
import { useFormik } from "formik";
import { lifeValidation } from "config/schema";
import { toast } from "react-toastify";

const Questionare = () => {
  const dispatch = useAppDispatch();
  const params: any = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(getQuestionsThunk({ policyId: params?.policyId }));
  }, []);

  const questionValue = useAppSelector((state) => state.rootReducer.kypSlice.questionsValue);
  const isLoading = useAppSelector((state) => state.rootReducer.kypSlice.loadingLifeQuality);

  const { values, handleSubmit, setFieldValue, initialValues, errors }: any = useFormik({
    initialValues: questionValue?.QuestionValues,
    enableReinitialize: true,
    validationSchema: lifeValidation,
    onSubmit: async (values: any) => {
      dispatch(postQualityCheckThunk({ changeQuestionValues: values, policyId: params?.policyId }))
        .unwrap()
        .then((res) => {
          if (res.success) navigate(`/kyp/kyp-life-result/${params?.policyId}`);
        });
    }
  });

  const padding = "px-3 md:px-7 py-3 md:py-5";
  const formProps = { values, setFieldValue, initialValues };

  const validateAtLeastOneTrue = (values: any) => {
    if (values.POLYFYX_QH1) {
      const checkboxKeys = Array.from({ length: 12 }, (_, i) => `POLYFYX_QH1_1_${i + 1}`);
      const atLeastOneChecked = checkboxKeys.some((key) => values[key] === true);

      if (!atLeastOneChecked) {
        toast.error("Please select atleast one Pre-Existing Disease");
        return false;
      }
    }
    return true;
  };

  const validateAtLeastOneSelected = (values: any) => {
    if (values.POLYFYX_QH2) {
      if (!values.POLYFYX_QH2_1 && !values.POLYFYX_QH2_2 && !values.POLYFYX_QH2_3) {
        toast.error("Please select at least one option: Smoker, Alcohol Consumer, or alcohol.");
        return false;
      }
    }
    return true;
  };

  const validateNomineeDetails = (values: any) => {
    if (!values.POLYFYX_QC4) {
      const nomineeArray = values.POLYFYX_QC4_1;
      if (Array.isArray(nomineeArray)) {
        const isAnyNomineeInvalid = nomineeArray.some((nominee) => !nominee.NomineeName?.trim() || !nominee.Relationship?.trim());

        if (isAnyNomineeInvalid) {
          toast.error("Nominee details cannot be empty.");
          return false;
        }
      }
    }
    return true;
  };

  const getFirstError = (errors: any) => {
    for (const field in errors) {
      if (typeof errors[field] === "object" && errors[field] !== null) {
        const nestedError = getFirstError(errors[field] as any);
        if (nestedError) {
          toast.error(nestedError);
          return false;
        }
      } else if (typeof errors[field] === "string" && errors[field]) {
        toast.error(errors[field] as string);
        return false;
      }
    }

    return true;
  };

  const validationChecker = () => {
    if (!validateAtLeastOneTrue(values)) return;
    else if (!validateAtLeastOneSelected(values)) return;
    else if (!validateNomineeDetails(values)) return;
    else if (!getFirstError(errors)) return;
    return true;
  };

  return (
    <>
      <h1 className="text-xl sm:text-2xl font-extrabold mb-4 sm:mb-6 ">Know Your Policy</h1>
      <Card className="w-full" parentClassName="mb-5">
        <div className={`font-medium text-[13px] md:text-base flex gap-3 items-center  border-b border-border-color ${padding}`}>
          <img src={preview} />
          <p>To generate the result, please respond to the following questions.</p>
        </div>

        <div>
          <div>
            <p className={`font-extrabold text-base md:text-xl ${padding}`}>Health & Lifestyle</p>
            {questionValue?.Questions &&
              values &&
              questionValue?.Questions["Health&lifestyle"] &&
              questionValue?.Questions["Health&lifestyle"].map((obj: any, index: number) => {
                return <HealthLifestyle key={index} padding={padding} questions={obj} formProps={formProps} />;
              })}
          </div>

          <div>
            <p className={`font-extrabold text-base md:text-xl ${padding}`}>Financial & Occupation</p>
            {questionValue?.Questions &&
              values &&
              questionValue?.Questions["Financial&occupation"] &&
              questionValue?.Questions["Financial&occupation"].map((obj: any, index: number) => {
                return <FinancialOccupation key={index} padding={padding} questions={obj} formProps={formProps} />;
              })}
          </div>

          <div>
            <p className={`font-extrabold text-base md:text-xl ${padding}`}>Contact & Admin</p>
            {questionValue?.Questions &&
              values &&
              questionValue?.Questions["ContactDetails&admin"] &&
              questionValue?.Questions["ContactDetails&admin"].map((obj: any, index: number) => {
                return <ContactAdmin key={index} padding={padding} questions={obj} formProps={formProps} />;
              })}
          </div>
        </div>

        <div className="hidden md:flex justify-center items-center py-5 border-t-[1px] border-border-color mt-10">
          <Button title="NEXT" onClick={() => (validationChecker() ? handleSubmit() : "")} isLoading={isLoading} />
        </div>
      </Card>
      <Card className="w-full fixed bottom-0 left-0 rounded-t-[15px] bg-white flex md:hidden justify-center py-5" parentClassName={`border-2 border-gray-300 shadow-none `}>
        <Button title="NEXT" onClick={() => (validationChecker() ? handleSubmit() : "")} isLoading={isLoading} />
      </Card>
    </>
  );
};

export default Questionare;
